import {useMemo} from "react";

import {filterCasesByStatus} from "../model/filterCasesByStatus";
import {sortCases} from "../model/sortCases";

type UseCaseListViewProps = {
  cases: any[];
  selectedStatus: string;
  sortColumn: string | null;
  sortOrder: "asc" | "desc";
};

export const useCaseListView = ({
  cases,
  selectedStatus,
  sortColumn,
  sortOrder,
}: UseCaseListViewProps) => {
  const filteredCases = useMemo(() => {
    return filterCasesByStatus({cases, selectedStatus});
  }, [cases, selectedStatus]);

  const sortedCases = useMemo(() => {
    return sortCases({cases: filteredCases, sortColumn, sortOrder});
  }, [filteredCases, sortColumn, sortOrder]);

  return {
    filteredCases,
    sortedCases,
  };
};
